<template>
    <div class="quote-reply col-md-12">
        <div id="sending" v-if="formState == 'sending'">
            <div class="overlay"></div>
            <div class="form-sending"></div>
        </div>
        <div class="row mt-2">
            <div class="quote-reply__button-row">
                <button
                    class="btn btn--success btn--hollow"
                    @click="setMode('accept')"
                    v-bind:class="{'btn--active' : formData.action == 'accept'}"
                    v-if="canAccept">
                    Hyväksy tarjous
                </button>
                <button
                    class="btn btn--danger btn--hollow"
                    @click="setMode('reject')"
                    v-bind:class="{'btn--active' : formData.action == 'reject'}"
                    v-if="canReject">Hylkää tarjous
                </button>
                <button
                    class="btn btn--call-to-action btn--hollow"
                    @click="setMode('info')"
                    v-bind:class="{'btn--active' : formData.action == 'info'}">Kysy lisätietoja
                </button>
            </div>
        </div>
        <div class="row">
            <transition name="fade">
                <form v-on:submit.prevent="sendReply" method="post" id="send-quote" name="send-quote" class="col-md-9 quote-reply__form"
                      v-if="formData.action !== null">
                    <div class="row">
                        <div class="col-md-8">
                            <turndown-reason-field
                                v-if="formData.action == 'reject'"
                                :selectedOption="formData.selectedTurnDownReason"
                                :turnDownOptions=turnDownRadioOptions
                                @change="setTurnDownReason">
                            </turndown-reason-field>
                            <div class="quote-reply__textarea">
                                <label for="message">{{ messageLabel }}</label>
                                <textarea rows="12" v-model="formData.message" id="message"></textarea>
                            </div>
                            <div v-if="formData.action == 'accept'">
                                <tos :has-contract="hasContract" :id=id :checksum=checksum v-model="formData.tos"></tos>
                            </div>
                            <button
                                type="submit"
                                v-bind:class="getSubmitButtonClass(formData.action)"
                                class="btn btn--block btn--send-message">
                                {{ buttonText }}
                            </button>
                        </div>
                    </div>
                </form>
            </transition>
        </div>
    </div>
</template>

<script>
    import FormData from '../modules/FormData';
    import Messages from '../modules/Messages';
    import TurndownReasonField from './TurndownReasonField';
    import Tos from './Tos';
    import Routes from '../modules/Routes';

    const canQuoteBeAccepted = (quote) => {
        const statuses = ['on-hold', 'open', 're-opened'];
        if (quote !== null) {
            if (statuses.indexOf(quote.Status.quoteStatusSlug) !== -1) {
                return true;
            }
        }
        return false;
    };

    export default {
        components: {
            TurndownReasonField,
            Tos
        },
        mounted() {
        },
        props: {
            id: {
                type: Number
            },
            checksum: {
                type: String
            },
            quote: {
                type: Object,
                required: true
            },
            history: {
                type: Array,
                required: true
            },
            turnDownOptions: {
                type: Array
            },
            hasContract: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                route: '_public_api_quote_accept',
                formVisible: true,
                formState: 'not-sent',
                buttonText: 'Hyväksy tarjous & lähetä',
                messageLabel: 'Kerro bändille tässä vielä esim. tarkemmasta aikataulusta',
                formData: {
                    message: '',
                    selectedTurnDownReason: {},
                    tos: false,
                    action: canQuoteBeAccepted(this.quote) ? 'accept' : null,
                }
            };
        },
        computed: {
            turnDownRadioOptions() {
                return this.turnDownOptions.map((item) => {
                    return { id: item.id, name: item.locale.name };
                });
            },
            canAccept() {
                return canQuoteBeAccepted(this.quote);
            },
            canReject() {
                return this.canAccept;
            }
        },
        methods: {
            getUrl() {
                return Routes.generate(this.route, { id: this.id, checksum: this.checksum });
            },
            sendReply() {
                if (!this.validate()) {
                    this.$ga.event('Quote history', 'Validation failed');
                    return false;
                }
                this.formState = 'sending';
                let formData = new FormData(this.$data.formData);
                this.$http.post(this.getUrl(), JSON.stringify(formData.parseQuoteReplyData()), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    Messages.fromResponse(response);
                    this.formState = 'sent';
                    this.$emit('formsent');
                    this.$ga.event('Quote history', 'Message sent successfully');
                    gtag('event', 'send_quote_message');
                    this.formData.action = null;
                }, (response) => {
                    Messages.fromResponse(response);
                    this.formState = 'error';
                    this.$ga.event('Quote history', 'Message sending failed');
                });
                return true;
            },
            getSubmitButtonClass(formAction) {
                switch (formAction) {
                    case 'accept':
                        return 'btn--success';
                    case 'reject':
                        return 'btn--danger';
                    default:
                        return 'btn--call-to-action';
                }
            },
            setMode(action) {
                if (action === this.formData.action) {
                    this.formData.action = null;
                    return this.formData.action;
                }

                switch (action) {
                    case 'accept':
                        this.buttonText = 'Hyväksy tarjous & lähetä';
                        this.messageLabel = 'Kerro bändille tässä vielä esim. tarkemmasta aikataulusta';
                        this.route = '_public_api_quote_accept';
                        break;
                    case 'reject':
                        this.buttonText = 'Hylkää tarjous & lähetä';
                        this.messageLabel = 'Viesti bändille';
                        this.route = '_public_api_quote_reject';
                        break;
                    default:
                        this.buttonText = 'Lähetä viesti';
                        this.messageLabel = 'Viestisi bändille / artistille';
                        this.route = '_public_api_quote_ask';
                }
                this.formData.action = action;

                return this.formData.action;
            },
            setTurnDownReason(turnDownReason) {
                this.$set(this.formData, 'selectedTurnDownReason', turnDownReason);
            },
            validate() {
                let errors = [];
                if (this.$data.formData.message.length < 10) {
                    errors.push('Kirjoita artistille hieman lisätietoja tarjouspyyntöön liittyen');
                }
                if (this.$data.formData.action === 'accept' && !this.$data.formData.tos) {
                    errors.push('Sinun täytyy hyväksyä tilausehdot väärinkäsitysten välttämiseksi');
                }
                if (this.$data.formData.action === 'reject' && !this.$data.formData.selectedTurnDownReason.id) {
                    errors.push('Valitse syy, miksi päätit hylätä tarjouksen');
                }
                if (errors.length > 0) {
                    Messages.plainTextErrorFromArray('Tarkista seuraavat tiedot', errors);
                    return false;
                }
                return true;
            }
        }
    };
</script>
